import { Link2, Undo2 } from 'lucide-react';
import { Button } from '@/components/ui';

/** Status and actions while linking a Record point to a Field point. */
export const LinkModeBar = ({
  source,
  linkedCount,
  onUndo,
  onDone,
}: {
  source: string | null;
  linkedCount: number;
  onUndo?: () => void;
  onDone: () => void;
}) => (
  <div className="flex flex-wrap items-center gap-2 rounded-lg border border-accent/20 bg-accent-muted px-3 py-1.5">
    <Link2 aria-hidden="true" className="size-4 shrink-0 text-accent" />
    <p role="status" className="min-w-0 flex-1 text-sm text-fg">
      {source !== null ? (
        <>
          Record <span className="font-mono font-semibold">{source}</span>:
          choose its Field point
        </>
      ) : (
        'Choose a Record point to link'
      )}
    </p>
    <div className="flex items-center gap-1">
      {onUndo && linkedCount > 0 && (
        <Button
          size="sm"
          variant="ghost"
          leadingIcon={<Undo2 />}
          onClick={onUndo}
        >
          Undo ({linkedCount})
        </Button>
      )}
      <Button size="sm" onClick={onDone}>
        Done
      </Button>
    </div>
  </div>
);
